// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/font/PlusJakartaSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/font/PlusJakartaSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/font/PlusJakartaSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/font/PlusJakartaSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/font/PlusJakartaSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/font/Tajawal-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/font/Tajawal-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/font/Tajawal-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/font/Tajawal-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/font/Tajawal-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
@media (min-width: 1400px) {

  .\\!container {
    max-width: 1400px !important;
  }
}
::-webkit-scrollbar {
    width: 4px;
  }
::-webkit-scrollbar-track {
    background: transparent;
  }
::-webkit-scrollbar-thumb {
    background-color: grey;
    border-radius: 20px;
  }
input::-moz-placeholder {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #919aad;
  }
input::placeholder {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #919aad;
  }
.placeholder {
    position: absolute;
    background-color: #ebf4fd;
    border-radius: 3px;
    border: dashed 1px #368fe7;
  }
@keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
@media screen and (max-width: 768px) {
    :root {
      font-size: 14px;
    }
  }
@media screen and (max-width: 460px) {
    :root {
      font-size: 12px;
    }
  }
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-left-1 {
  left: -0.25rem;
}
.-top-1 {
  top: -0.25rem;
}
.z-50 {
  z-index: 50;
}
.z-\\[1\\] {
  z-index: 1;
}
.m-0 {
  margin: 0px;
}
.-mb-spacing {
  margin-bottom: -20px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-spacing {
  margin-top: 20px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.\\!h-12 {
  height: 3rem !important;
}
.h-12 {
  height: 3rem;
}
.h-24 {
  height: 6rem;
}
.h-4 {
  height: 1rem;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-full {
  height: 100%;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-full {
  width: 100% !important;
}
.w-4 {
  width: 1rem;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-fi-lg {
  width: 100%;
}
.w-fi-md {
  width: 45%;
}
.w-full {
  width: 100%;
}
.min-w-full {
  min-width: 100%;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[inherit\\] {
  max-width: inherit;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-spacing {
  gap: 20px;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded-fi {
  border-radius: 0.375rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-fi-border {
  --tw-border-opacity: 1;
  border-color: rgb(206 212 218 / var(--tw-border-opacity));
}
.border-fi-danger {
  --tw-border-opacity: 1;
  border-color: rgb(220 53 69 / var(--tw-border-opacity));
}
.border-fi-primary {
  --tw-border-opacity: 1;
  border-color: rgb(86 147 30 / var(--tw-border-opacity));
}
.border-fi-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(53 113 155 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!bg-fi-bg {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-fi-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-fi-bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-fi-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(220 53 69 / var(--tw-bg-opacity));
}
.bg-fi-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(86 147 30 / var(--tw-bg-opacity));
}
.bg-fi-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(53 113 155 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.fill-fi-font {
  fill: #212529;
}
.p-0 {
  padding: 0px;
}
.p-4 {
  padding: 1rem;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-fi {
  padding: 0.375rem 0.75rem;
}
.p-fi-lg {
  padding: 1.5rem 1.5rem;
}
.p-fi-spacing {
  padding: 20px;
}
.p-fi-tr {
  padding: 1rem 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.py-fi-spacing {
  padding-top: 20px;
  padding-bottom: 20px;
}
.text-start {
  text-align: start;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.text-fi-bg-secondary {
  --tw-text-opacity: 1;
  color: rgb(249 249 249 / var(--tw-text-opacity));
}
.text-fi-danger {
  --tw-text-opacity: 1;
  color: rgb(220 53 69 / var(--tw-text-opacity));
}
.text-fi-font {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}
.text-fi-primary {
  --tw-text-opacity: 1;
  color: rgb(86 147 30 / var(--tw-text-opacity));
}
.text-fi-secondary {
  --tw-text-opacity: 1;
  color: rgb(53 113 155 / var(--tw-text-opacity));
}
.text-fi-secondary-font {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\[-moz-appearance\\:_textfield\\] {
  -moz-appearance: textfield;
}
@font-face {
  font-family: "Plus Jakarta Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}
@font-face {
  font-family: "Plus Jakarta Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 500;
}
@font-face {
  font-family: "Plus Jakarta Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 600;
}
@font-face {
  font-family: "Plus Jakarta Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 700;
}
@font-face {
  font-family: "Plus Jakarta Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 800;
}

@font-face {
  font-family: "Tajwal";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 400;
}
@font-face {
  font-family: "Tajwal";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 500;
}
@font-face {
  font-family: "Tajwal";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: 600;
}
@font-face {
  font-family: "Tajwal";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: 700;
}
@font-face {
  font-family: "Tajwal";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: 800;
}
html:lang(ar) .react-tel-input .selected-flag {
  padding: 0;
  padding-inline-start: 8px !important;
}
html:lang(ar) .react-tel-input .selected-flag .arrow {
  left: auto !important;
  right: 20px !important;
}
html:lang(ar) .react-tel-input .form-control {
  text-align: end;
  padding-inline-end: 48px;
}

html {
  font-family: "Plus Jakarta Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}
.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
  font-size: 1.2rem;
  color: #10244c !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 164%;
}

.react-calendar__month-view__weekdays__weekday {
  color: #368fe7 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--weekend,
.react-calendar__tile.react-calendar__month-view__days__day {
  color: #10244c !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.switch-checkbox {
  height: 0;
  width: 0;
  visibility: hidden;
}

.switch-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 72px;
  height: 32px;
  background: grey;
  border-radius: 100px;
  position: relative;
  transition: background-color 0.2s;
}

.switch-label .switch-button {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 28px;
  height: 28px;
  border-radius: 45px;
  transition: 0.2s;
  background: #fff;
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
}

.switch-checkbox:checked + .switch-label .switch-button {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}

body.seeds-root input[type=checkbox],
body input[type=checkbox] {
  width: 25px;
  height: 25px;
  border: 2px solid #919aad;
  accent-color: #368fe7;
  -moz-appearance: checkbox !important;
  -webkit-appearance: checkbox !important;
}

label {
  margin-bottom: 0;
}

.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:bg-fi-danger-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(189 33 48 / var(--tw-bg-opacity));
}

.hover\\:bg-fi-primary-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 127 26 / var(--tw-bg-opacity));
}

.hover\\:bg-fi-secondary-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(42 88 133 / var(--tw-bg-opacity));
}

.hover\\:text-fi-danger-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(189 33 48 / var(--tw-text-opacity));
}

.hover\\:text-fi-primary-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(75 127 26 / var(--tw-text-opacity));
}

.hover\\:text-fi-secondary-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(42 88 133 / var(--tw-text-opacity));
}

@media (min-width: 768px) {

  .tablet\\:w-fi-lg {
    width: 100%;
  }

  .tablet\\:w-fi-md {
    width: 45%;
  }

  .tablet\\:w-fi-sm {
    width: 30%;
  }

  .tablet\\:flex-row {
    flex-direction: row;
  }

  .tablet\\:flex-wrap {
    flex-wrap: wrap;
  }
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:m-0::-webkit-inner-spin-button {
  margin: 0px;
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:m-0::-webkit-outer-spin-button {
  margin: 0px;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  -webkit-appearance: none;
          appearance: none;
}`, "",{"version":3,"sources":["webpack://./index.scss"],"names":[],"mappings":"AAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;AACA;EAAA,sBAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAsFE;IACE,UAAA;EAXF;AAcA;IACE,uBAAA;EAZF;AAeA;IACE,sBAAA;IACA,mBAAA;EAbF;AAoCA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,cAAA;EAbF;AAQA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,cAAA;EAbF;AAeA;IACE,kBAAA;IACA,yBAAA;IACA,kBAAA;IACA,0BAAA;EAbF;AAsCA;IACE;MACE,UAAA;IAxBF;IA0BA;MACE,UAAA;IAxBF;EACF;AA6CA;IACE;MACE,eAAA;IAzBF;EACF;AA2BA;IACE;MACE,eAAA;IAzBF;EACF;AApKF;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;KAAA,qBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAGE;EACE,gCAAA;EACA,4CAAA;EACA,gBAAA;AADJ;AAIE;EACE,gCAAA;EACA,4CAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gCAAA;EACA,4CAAA;EACA,gBAAA;AAHJ;AAME;EACE,gCAAA;EACA,4CAAA;EACA,gBAAA;AAJJ;AAOE;EACE,gCAAA;EACA,4CAAA;EACA,gBAAA;AALJ;;AASE;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;AANJ;AASE;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;AARJ;AAWE;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;AATJ;AAYE;EACE,qBAAA;EACA,4CAAA;EACA,gBAAA;AAVJ;AAYE;EACE,UAAA;EACA,oCAAA;AAVJ;AAYE;EACE,qBAAA;EACA,sBAAA;AAVJ;AAYE;EACE,eAAA;EACA,wBAAA;AAVJ;;AAcA;EACE,4CAAA;EACA,mCAAA;EACA,kCAAA;EACA,uBAAA;AAXF;AA2HA;EAEE,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3BF;;AA6BA;EAEE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA3BF;;AA6BA;;EAEE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1BF;;AA6BA;EACE,SAAA;EACA,QAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iCAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;AA1BF;;AA6BA;EACE,sBAAA;EACA,4BAAA;AA1BF;;AA6BA;;EAEE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;EACA,uCAAA;AA1BF;;AA4BA;EACE,gBAAA;AAzBF;;AAnPA;EAAA,kBAmPC;EAnPD,kBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,kBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,kBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,kBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,oBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,oBAmPC;EAnPD;AAmPC;;AAnPD;EAAA,oBAmPC;EAnPD;AAmPC;;AAnPD;;EAAA;IAAA;EAmPC;;EAnPD;IAAA;EAmPC;;EAnPD;IAAA;EAmPC;;EAnPD;IAAA;EAmPC;;EAnPD;IAAA;EAmPC;AAAA;;AAnPD;EAAA;AAmPC;;AAnPD;EAAA,wBAmPC;UAnPD;AAmPC;;AAnPD;EAAA;AAmPC;;AAnPD;EAAA,wBAmPC;UAnPD;AAmPC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml:lang(en) {\n  @font-face {\n    font-family: \"Plus Jakarta Sans\";\n    src: url(\"../assets/font/PlusJakartaSans-Regular.ttf\");\n    font-weight: 400;\n  }\n\n  @font-face {\n    font-family: \"Plus Jakarta Sans\";\n    src: url(\"../assets/font/PlusJakartaSans-Medium.ttf\");\n    font-weight: 500;\n  }\n\n  @font-face {\n    font-family: \"Plus Jakarta Sans\";\n    src: url(\"../assets/font/PlusJakartaSans-SemiBold.ttf\");\n    font-weight: 600;\n  }\n\n  @font-face {\n    font-family: \"Plus Jakarta Sans\";\n    src: url(\"../assets/font/PlusJakartaSans-Bold.ttf\");\n    font-weight: 700;\n  }\n\n  @font-face {\n    font-family: \"Plus Jakarta Sans\";\n    src: url(\"../assets/font/PlusJakartaSans-ExtraBold.ttf\");\n    font-weight: 800;\n  }\n}\nhtml:lang(ar) {\n  @font-face {\n    font-family: \"Tajwal\";\n    src: url(\"../assets/font/Tajawal-ExtraLight.ttf\");\n    font-weight: 400;\n  }\n\n  @font-face {\n    font-family: \"Tajwal\";\n    src: url(\"../assets/font/Tajawal-Light.ttf\");\n    font-weight: 500;\n  }\n\n  @font-face {\n    font-family: \"Tajwal\";\n    src: url(\"../assets/font/Tajawal-Regular.ttf\");\n    font-weight: 600;\n  }\n\n  @font-face {\n    font-family: \"Tajwal\";\n    src: url(\"../assets/font/Tajawal-Medium.ttf\");\n    font-weight: 700;\n  }\n\n  @font-face {\n    font-family: \"Tajwal\";\n    src: url(\"../assets/font/Tajawal-Bold.ttf\");\n    font-weight: 800;\n  }\n  .react-tel-input .selected-flag {\n    padding: 0;\n    padding-inline-start: 8px !important;\n  }\n  .react-tel-input .selected-flag .arrow {\n    left: auto !important;\n    right: 20px !important;\n  }\n  .react-tel-input .form-control {\n    text-align: end;\n    padding-inline-end: 48px;\n  }\n}\n\nhtml {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\n@layer components {\n  ::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: grey;\n    border-radius: 20px;\n  }\n  .custom-grid {\n    display: grid;\n    grid-template-columns: 1fr minmax(450px, 500px);\n    grid-gap: 10px;\n    padding: 10px;\n  }\n  .tab-grid {\n    display: grid;\n    grid-template-rows: minmax(65px, 72px) 1fr;\n    grid-gap: 10px;\n    padding: 10px;\n  }\n  .calendar__input__grid {\n    display: grid;\n    grid-template-columns: 1fr minmax(20px, 1fr) 1fr;\n  }\n  .calendar__data__grid {\n    display: grid;\n    grid-template-columns: minmax(200px, max-content);\n    place-content: center;\n  }\n  input::placeholder {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    color: #919aad;\n  }\n  .placeholder {\n    position: absolute;\n    background-color: #ebf4fd;\n    border-radius: 3px;\n    border: dashed 1px #368fe7;\n  }\n\n  .remove_button:hover {\n    span {\n      color: white;\n    }\n  }\n\n  .svg-white {\n    path {\n      stroke: white;\n    }\n  }\n  .svg-blue {\n    svg {\n      path {\n        stroke: #368fe7;\n      }\n    }\n  }\n\n  .fade-in {\n    animation: fade-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n  }\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  .assign-item:hover,\n  .assign-item[data-active=\"true\"] {\n    position: relative;\n    ::after {\n      content: \"\";\n      position: absolute;\n      border: 1px solid #405070;\n      background-color: transparent;\n      border-radius: 100%;\n      inset: 0;\n      z-index: 1;\n      animation: fade-in 0.3s ease-in-out forwards;\n    }\n  }\n\n  .cards-shadow {\n    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.22);\n  }\n\n  @media screen and (max-width: 768px) {\n    :root {\n      font-size: 14px;\n    }\n  }\n  @media screen and (max-width: 460px) {\n    :root {\n      font-size: 12px;\n    }\n  }\n}\n\n.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {\n  $royalBlue: #10244c;\n  font-size: 1.2rem;\n  color: $royalBlue !important;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 164%;\n}\n.react-calendar__month-view__weekdays__weekday {\n  $blue500: #368fe7;\n  color: $blue500 !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.react-calendar__tile.react-calendar__month-view__days__day.react-calendar__month-view__days__day--weekend,\n.react-calendar__tile.react-calendar__month-view__days__day {\n  color: #10244c !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.switch-checkbox {\n  height: 0;\n  width: 0;\n  visibility: hidden;\n}\n\n.switch-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  width: 72px;\n  height: 32px;\n  background: grey;\n  border-radius: 100px;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.switch-label .switch-button {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 28px;\n  height: 28px;\n  border-radius: 45px;\n  transition: 0.2s;\n  background: #fff;\n  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);\n}\n\n.switch-checkbox:checked + .switch-label .switch-button {\n  left: calc(100% - 2px);\n  transform: translateX(-100%);\n}\n\nbody.seeds-root input[type=\"checkbox\"],\nbody input[type=\"checkbox\"] {\n  width: 25px;\n  height: 25px;\n  border: 2px solid #919aad;\n  accent-color: #368fe7;\n  -moz-appearance: checkbox !important;\n  -webkit-appearance: checkbox !important;\n}\nlabel {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
